import { Component } from '@angular/core';

@Component({
  selector: 'app-editmissing',
  templateUrl: './editmissing.component.html',
  styleUrl: './editmissing.component.scss'
})
export class EditmissingComponent {

}
